/* tslint:disable */
/* eslint-disable */
/**
 * Authentication Service Api
 * Authentication Service Api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebTokenResponse
 */
export interface WebTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof WebTokenResponse
     */
    token: string;
}

/**
 * Check if a given object implements the WebTokenResponse interface.
 */
export function instanceOfWebTokenResponse(value: object): value is WebTokenResponse {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function WebTokenResponseFromJSON(json: any): WebTokenResponse {
    return WebTokenResponseFromJSONTyped(json, false);
}

export function WebTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

  export function WebTokenResponseToJSON(json: any): WebTokenResponse {
      return WebTokenResponseToJSONTyped(json, false);
  }

  export function WebTokenResponseToJSONTyped(value?: WebTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

